import { render, staticRenderFns } from "./AdditionalContact.vue?vue&type=template&id=04f83798&scoped=true&"
import script from "./AdditionalContact.vue?vue&type=script&lang=js&"
export * from "./AdditionalContact.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalContact.vue?vue&type=style&index=0&id=04f83798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f83798",
  null
  
)

export default component.exports